import React, { PropTypes } from 'react';
import { Link } from 'react-router-dom'
import { formatDate } from '../utils/date';


const ProductTable = ({rows, removeRow}) => (
  <table className="table table-bordered row-container">
    <thead>
      <tr>
        <th>Kods</th>
        <th>Periods</th>
        <th className="text-sm-left">Temats</th>
        <th>Noma</th>
        <th className="text-sm-right">Ražošana</th>
        <th className="text-sm-right">Montāža un demontāža</th>
        <th className="text-sm-right">Nodeva</th>
        <th className="text-sm-right">Kopā bez PVN</th>
      </tr>
    </thead>
    <tbody>
    {rows.map((
      [{
        id,
        dateFrom,
        dateTo,
        subject,
        product: {
          id: productId,
          object: objectId,
          code
        }
      }, {
        unitsInMonths,
        rentDiscounted,
        discount,
        productionPrice,
        setupPrice,
        tax,
        totalWoVat,

        totalRent,
        totalTax,
        totalDiscount        
      }], idx) => {
      return (
        <tr key={idx} >
          <td><Link to={`/browse/${objectId}/${productId}/`}>{code}</Link></td>
          <td>
            {formatDate(dateFrom)} - {formatDate(dateTo)} <span className="float-right text-muted">{unitsInMonths} mēn.</span>
          </td>
          <td>{(subject && subject.name) || "Komercreklāma"}</td>
          <td className="text-sm-right">
            {totalRent}
            {parseFloat(totalDiscount) > 0 && <div className="discount">-{totalDiscount}</div>}
          </td>
          <td className="text-sm-right">{productionPrice}</td>
          <td className="text-sm-right">{setupPrice}</td>
          <td className="text-sm-right">{totalTax}</td>
          <td className="text-sm-right total-cell">
            {totalWoVat}
            { removeRow && <button className="btn btn-link remove-row" onClick={() => removeRow(id)}>
              <i className="fa fa-times text-danger"/>
            </button>}
          </td>
        </tr>
      )}
    )}
    </tbody>
  </table>  
);

ProductTable.propTypes = {
  rows: PropTypes.array.isRequired,
  removeRow: PropTypes.func
};

export default ProductTable;


// WEBPACK FOOTER //
// ./src/components/ProductTable.js